export default __webpack_public_path__ + "static/3-559281c01e81c0eedac585486e6df7cf.jpg";